module.exports = __webpack_public_path__ + "static/images00003.0e9ab002.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/click/images00003.png
// module id = 270
// module chunks = 1 2